var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3563 0C7.85661 0.00294898 5.46013 0.997261 3.69257 2.76482C1.925 4.53238 0.930693 6.92886 0.927744 9.42857C0.92475 11.4713 1.59201 13.4587 2.82717 15.0857C2.82717 15.0857 3.08432 15.4243 3.12632 15.4731L10.3563 24L17.5897 15.4689C17.6275 15.4234 17.8855 15.0857 17.8855 15.0857L17.8863 15.0831C19.1209 13.4568 19.7878 11.4704 19.7849 9.42857C19.7819 6.92886 18.7876 4.53238 17.0201 2.76482C15.2525 0.997261 12.856 0.00294898 10.3563 0ZM10.3563 12.8571C9.67821 12.8571 9.01533 12.6561 8.4515 12.2793C7.88768 11.9026 7.44823 11.3671 7.18873 10.7406C6.92923 10.1141 6.86133 9.42477 6.99362 8.75969C7.12592 8.09461 7.45246 7.4837 7.93195 7.00421C8.41144 6.52471 9.02236 6.19817 9.68744 6.06588C10.3525 5.93359 11.0419 6.00148 11.6684 6.26098C12.2949 6.52048 12.8303 6.95993 13.2071 7.52376C13.5838 8.08759 13.7849 8.75046 13.7849 9.42857C13.7838 10.3375 13.4222 11.2089 12.7794 11.8517C12.1367 12.4944 11.2653 12.856 10.3563 12.8571Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoPoint);
export default __webpack_public_path__ + "static/media/geo_point.a2d3b1e394cefc873988a56ce26d9536.svg";
export { ForwardRef as ReactComponent };